import { render, staticRenderFns } from "./RejectReport.vue?vue&type=template&id=46b07fde&scoped=true&"
import script from "./RejectReport.vue?vue&type=script&lang=js&"
export * from "./RejectReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b07fde",
  null
  
)

export default component.exports